import React, { Fragment, useContext, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from "@material-ui/core";

// Contexts
import AlertContext from "../../../../../../context/alert/AlertContext";
import OrderContext from "../../../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  form: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  button: {
    textTransform: "none",
  },
}));

const InfoContact = ({ handleClose }) => {
  const classes = useStyles();

  const { setAlert } = useContext(AlertContext);
  const {
    modalFunction,
    modalValues,
    modalErrors,
    modalStates,
    setValues,
    setErrors,
    setModalStates,
    order,
    updateContactInfo,
  } = useContext(OrderContext);

  const handleChange = (e) => {
    const id = e.target.id;
    const value = e.target.value.trim();

    let new_values = Object.assign({}, modalValues);
    let new_errors = Object.assign({}, modalErrors);

    new_values[id] = value;

    // Regex
    const validEmailRegex =
      /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (id === "email") {
      if (!validEmailRegex.test(value)) {
        new_errors.email = "Email is invalid!";
      } else {
        new_errors.email = "";
      }
    }

    setValues(new_values);
    setErrors(new_errors);
  };

  const onSubmit = (e) => {
    e.preventDefault();

    let valid = true;

    // Validation - errors
    if (modalErrors.email) {
      valid = false;
    }

    if (valid) {
      // Check If Any Changes Made
      let new_changed = false;

      Object.entries(modalValues).map(([key, val]) => {
        if (val && order[key] !== val) {
          new_changed = true;
        }
      });

      if (new_changed) {
        setModalStates({
          submitted: true,
          changed: new_changed,
        });

        const customer_id = order.customer ? order.customer.id : "";
        console.log(order);
        updateContactInfo(order.store_name, customer_id, order.id, modalValues);
      } else {
        handleClose();
        setAlert("No changes has been made.", "info");
      }
    }
  };

  useEffect(() => {
    if (modalFunction === "contact_info") {
      setValues({
        email: order.email,
      });
      setErrors({
        email: null,
      });
    }
  }, [modalFunction]);

  return (
    modalFunction === "contact_info" && (
      <Fragment>
        <DialogTitle> Edit contact information </DialogTitle>
        <DialogContent dividers>
          <form className={classes.form}>
            <TextField
              fullWidth
              className={classes.textField}
              label="Email address"
              id="email"
              value={modalValues.email ? modalValues.email : ""}
              onChange={handleChange}
              error={modalErrors.email ? true : false}
              helperText={modalErrors.email ? modalErrors.email : ""}
            />
            {/* <TextField
                              fullWidth
                              className={classes.textField}
                              label="Phone number"
                              id="phone"
                              value={modalValues.phone}
                              onChange={handleChange}
                              error={modalErrors.phone ? true : false}
                              helperText={modalErrors.phone ? modalErrors.phone : ""}
                            /> */}{" "}
          </form>{" "}
        </DialogContent>
        <DialogActions className={classes.textField}>
          <Button
            variant="contained"
            color="primary"
            className={classes.button}
            onClick={onSubmit}
            disabled={modalStates.submitted}
          >
            Save{" "}
          </Button>{" "}
          <Button
            variant="contained"
            className={classes.button}
            onClick={handleClose}
            disabled={modalStates.submitted}
          >
            Cancel{" "}
          </Button>{" "}
        </DialogActions>{" "}
      </Fragment>
    )
  );
};

export default InfoContact;
